import { ABERRANT_TYPES } from '@/constants/aberrantCodes'

const FILTER_BY = ':'
const AND = '+'
const OR = '|'
const getRelevantAberrants = `(aberrant=true${AND}(${Object.values(ABERRANT_TYPES)
  .map((aberrant) => `aberrantCode=${aberrant}`)
  .join(OR)}))`
const getAllNonAberrantTransactions = '(aberrant=false)'

const transactionPath = 'loyalty.operations.operation'

const userFields = {
  transaction: 'loyalty.operations.operation',
  hasWallet: 'individual.hasWallet',
  language: 'individual.language',
  isOptOutTotal: 'individual.optOut.isOptOutTotal',
  coBrandedCards: 'loyalty.coBrandedCards.coBrandedCard',
  subscribedBonuses: 'loyalty.subscribedBonuses.subscribedBonus',
  loyaltyCards: 'loyalty.loyaltyCards',
  balances: 'loyalty.balances',
  memberInfo: 'loyalty.memberInfo',
  memberGifts: 'loyalty.memberGifts',
  subscriptionCards: 'loyalty.subscriptionCards',
  favoritesHotels: 'individual.favorites.hotels',
  awardType: 'loyalty.awardTypes.awardType',
  freenight: 'loyalty.freenights.freenight',
  allSignatureSubscriptions: 'loyalty.allSignatureSubscriptions',
  optins: 'individual.individualSubscriptions.individualSubscription',
  statusGifts: 'loyalty.statusGifts',
  statusMatches: 'loyalty.statusMatches',
  individualName: 'individual.individualName',
  isLoyaltyMember: 'individual.isLoyaltyMember',
  isNameUpdateAllowed: 'individual.isNameUpdateAllowed',
  contactMediums: 'contactMediums.contactMedium',
  nationality: 'individual.nationality',
  authentication: 'authentication.idpInformation',
  placeOfBirth: 'individual.placeOfBirth',
  birthDate: 'individual.birthDate',
  individualContracts: 'individual.individualContracts',
  pmid: 'individual.pmid'
}

export const userFieldsString = String(Object.values(userFields))

export const filterOperations = [
  transactionPath,
  FILTER_BY,
  getRelevantAberrants,
  OR,
  getAllNonAberrantTransactions
].join('')
